let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h7oxu"), load("lE3cg")]).then(() => parcelRequire('dp2qz'));